export const stopPropagation = (event: { stopPropagation: () => void }) => event.stopPropagation();

export const preventDefault = (event: { preventDefault: () => void }) => event.preventDefault();

export const triggerMouseDown = (element: Element) =>
  element.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
